import React from 'react'

// Aegis Icon
export const AegisIcon = () => {
    return (
        <svg className='aegis-icon' viewBox='-280 -260 280 260'>
            <path d='M -43 -235 C -7 -220 -3 -202 -20 -139 C -54.249 -39.277 -105 -10 -130 -10 C -173 -10 -207.613 -49.361 -242.488 -132.976 C -267.278 -208.188 -248.0733 -216.0493 -217.277 -235.499 C -146.268 -267.012 -116 -267 -43 -235 Z'/>
        </svg>
    )
}